import { Button, createStyles, Fab, Theme, withStyles, WithStyles } from "@material-ui/core";
import { ShareOutlined, ShareRounded } from "@material-ui/icons";
import classNames from "classnames";
import { debounce } from "lodash";
import React from "react";
import { Id } from "shared/src/models/framework/db";
import { Mode } from "shared/src/models/poll";
import { PollCard } from "shared/src/network/requests/poll/poll-req-models";
import { commonClasses } from "../styles";
import { navigatorShare } from "../utils/share";
import ShareTemplate from "./ShareTemplate";

const styles = (theme: Theme) =>
    createStyles({
        ...commonClasses,
    });

type Props = WithStyles<typeof styles> & {
    poll: Id<PollCard>;
    mode?: Mode;
    onClick?: () => void;
    hideShareOverlay?: () => void;
    label?: string;
    width?: number;
    large?: boolean;
    linkParam?: string;
    normalClassName?: string;
};

class Component extends React.Component<Props> {
    shareTemplate: React.RefObject<HTMLDivElement>;
    constructor(props: Props) {
        super(props);
        this.shareTemplate = React.createRef();
    }

    handleClick = debounce(
        async () => {
            const { poll, linkParam, onClick } = this.props;
            let files: Array<Blob> = [];
            // if (this.shareTemplate.current) {
            //     // request of S3 content from dom-to-image failing due to cors as image is already
            //     // loaded without cors header and cached. Cache bust will force fresh request with cors header.
            //     const imageBlob = await DomToImage.toBlob(this.shareTemplate.current, {
            //         cacheBust: true,
            //     });
            //     files = [new File([imageBlob], "flashmob.png", { type: imageBlob.type })];
            // }

            navigatorShare(poll, files, linkParam);
            onClick?.();
        },
        300,
        { leading: true, trailing: false }
    );

    render = () => {
        const { poll, mode, normalClassName } = this.props;
        return (
            <>
                <ShareTemplate ref={this.shareTemplate} poll={poll} />
                {mode === "YOURPOLL" ? (
                    <Button
                        variant="contained"
                        sx = {{
                            fontSize: "12px",
                            borderRadius: "10px"
                        }}
                        startIcon={<ShareOutlined />}
                        onClick={() => {
                            this.props.hideShareOverlay?.();
                            this.handleClick();
                        }}>
                        Share Flash
                    </Button>
                ) : (
                    <Fab
                        className={classNames(normalClassName)}
                        onClick={this.handleClick}
                        id={"btn-poll-share" + poll.id}
                        data-event={"poll_share"}>
                        {<ShareRounded />}
                    </Fab>
                )}
            </>
        );
    };
}

const ShareButton = withStyles(styles)(Component);

export default ShareButton;
